function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure " + obj); }
import { useOutlet, useSearchParams, useSiteData } from 'dumi';
import TouchEmulator from 'f2-touchemulator';
import React, { useEffect, useRef } from 'react';
import vl from 'umi-hd';
import flex from 'umi-hd/lib/flex';
import vh from 'umi-hd/lib/vh';
import vw from 'umi-hd/lib/vw';
import "./DemoLayout.less";
export var ROUTE_MSG_TYPE = 'dumi:update-iframe-route';

// available HD modes
var HD_MODES = {
  vl: vl,
  flex: flex,
  vw: vw,
  vh: vh
};
var MobileDemoLayout = function MobileDemoLayout(_ref) {
  _objectDestructuringEmpty(_ref);
  var target = useRef(null);
  var _useSiteData = useSiteData(),
    _useSiteData$themeCon = _useSiteData.themeConfig.hd,
    _useSiteData$themeCon2 = _useSiteData$themeCon === void 0 ? {} : _useSiteData$themeCon,
    _useSiteData$themeCon3 = _useSiteData$themeCon2.rules,
    rules = _useSiteData$themeCon3 === void 0 ? [{
      mode: 'vw',
      options: [100, 750]
    }] : _useSiteData$themeCon3;
  var outlet = useOutlet();
  var _useSearchParams = useSearchParams(),
    _useSearchParams2 = _slicedToArray(_useSearchParams, 1),
    params = _useSearchParams2[0];
  var compact = params.get('compact');
  var background = params.get('background');
  useEffect(function () {
    // Simulate the touch event of mobile terminal
    if (target.current && !('ontouchstart' in window)) {
      // fix https://github.com/umijs/dumi/issues/996
      TouchEmulator(document.documentElement);
    }
  }, []);
  useEffect(function () {
    var handler = function handler() {
      var clientWidth = document.documentElement.clientWidth;
      rules
      // discard invalid rules
      .filter(function (rule) {
        return HD_MODES[rule.mode];
      })
      // match first valid rule
      .some(function (rule) {
        if (
        // without min & max width
        Number.isNaN(rule.minWidth * 1) && Number.isNaN(rule.maxWidth * 1) ||
        // min width only
        Number.isNaN(rule.maxWidth * 1) && clientWidth > rule.minWidth ||
        // max width only
        Number.isNaN(rule.minWidth * 1) && clientWidth < rule.maxWidth ||
        // both min & max width
        clientWidth > rule.minWidth && clientWidth < rule.maxWidth) {
          HD_MODES[rule.mode].apply(HD_MODES, _toConsumableArray([].concat(rule.options)));
          document.documentElement.setAttribute('data-scale', 'true');
        }
        return true;
      });
    };
    handler();
    window.addEventListener('resize', handler);
    return function () {
      return window.removeEventListener('resize', handler);
    };
  }, [rules]);
  return /*#__PURE__*/React.createElement("div", {
    className: "dumi-mobile-demo-layout",
    ref: target,
    style: {
      padding: compact !== null ? 0 : compact,
      background: background
    },
    "data-html2sketch-container": true
  }, outlet);
};
export default MobileDemoLayout;